import { ACTIONS } from "../../../Models/ENUM";
import ARRAY from "../../../UTIL/ARRAY";
import CONQUER from "../../CONQUER";
import GameInstance from "../GameInstance";
import LOG, { log } from "../../../UTIL/LOG";
import DATE from "../../../UTIL/DATE";
import GameCurrency from "../WALLET/GameCurrency";
import ShopItem from "../SHOP/ShopItem";

class DailyRewards
{
    private key             : string = "DailyRewards";
    private gameInstance    : GameInstance;

    public data             : any = {};

    constructor( gameInstance:GameInstance )
    {
        this.gameInstance   = gameInstance;
    }

    public set()
    {
        let data : any      = this.get();
        let item            = data.items[ data.current ];
 
        if( !item || !data.canCollect ) return null;

        data.current++;
        data.rewardDate    = DATE.now();

        this.save();

        if( item.varName == "Lootbox" )
        {
            let shopItem : ShopItem = this.gameInstance.Shop.items[ item.value ];
            if( shopItem )
            {
                item.value = shopItem.set( true );
                return item;
            }
        }

        let currencyInstance : GameCurrency = this.gameInstance.Wallet.currencies[ item.varName ];
        if( currencyInstance ) 
        {
            currencyInstance.increase( item.value );
            return item;
        }

        return item;
    }

    public get() 
    {
        let data : any      = this.data = this.gameInstance.Data.data[ this.key ] || this.createObject();
 
        let current         = data.current = parseInt( data.current );
        let timePassed      = DATE.hoursFrom( data.rewardDate );

        data.canCollect     = data.rewardDate && timePassed > 16; 
 
        let items           = data.items;

        let isDirty         = false;

        if( timePassed > 36 || current >= items.length ) 
        {
            current = data.current = 0; 
            isDirty = true;
        }
 
        for( let n=0; n< items.length; n++ )
        {
            let item                            = items[n];

            if( n < current )   item.state      = "Collected";
            if( n > current )   item.state      = "Pending";
            if( n === current ) item.state      = "Ready";
        }

        if( !data.rewardDate ) 
        {
            data.rewardDate     = DATE.now();    
            isDirty             = true;
        }

        if( isDirty ) this.save();
        
        return data;
    }

    private createObject()
    {
        let data : any       = this.data = {};

        data.rewardDate      = 0;
        data.current         = 0;
        data.items           = [];
        data.canCollect      = false;

        for( let n = 0; n<15; n++ ) 
        {
            let varName : string = "Coin";
            let value   : any = (n+1) * 100;

            if( n === 4 || n === 9 || n === 14 )
            {
                varName = "Lootbox";

                if( n === 4 )   value = "Loot_Rare";
                if( n === 9 )   value = "Loot_Epic";
                if( n === 14 )  value = "Loot_Legendary";
            }

            data.items.push(
            {
                id      : n,
                varName : varName,
                value   : value,
                day     : "DAY " + ( n + 1 ),
                state   : "Pending"
            });
        }
 
        return this.save();
    }

    private save()
    {
        this.gameInstance.Data.set( this.key, this.data );
        return this.data;
    }
 
};

export default DailyRewards;